/**
 * @author Arul Vivek
 */
 import service from '../Common/'
 import constants from '../../../settings/shared/constants'

  function GetChatRunIds(start,end) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.chat.joblist+"?page="+start+"&size="+end,
            method: 'GET',
            headers: headers,
            data:  ''
        }); 
 }

   function GetChatProject(start,end) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.chat.projectlist+"?page="+start+"&size="+end,
            method: 'GET',
            headers: headers,
            data:  ''
        }); 
 }

    function GetChatMessages(id,start,end) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.chat.Getmessagelist+id+"?page="+start+"&size="+end,
            method: 'GET',
            headers: headers,
            data:  ''
        }); 
 }

 function GetChatIdentifierMessages(id,start,end) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.chat.Getchatmessage+id+"?page="+start+"&size="+end,
            method: 'GET',
            headers: headers,
            data:  ''
        }); 
 }

  function PostMedia(mediaData,files) {
    var formData = new FormData();
    formData.append("file", files[0]);
    formData.append('path', JSON.stringify(mediaData));
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.chat.PostMediamessage,
            method: 'POST',
            headers: headers,
            data:  formData
        }); 
 }
  
//To export run function
const ChatService = {
    GetChatRunIds,GetChatProject,GetChatMessages,GetChatIdentifierMessages,PostMedia
}
export default ChatService;
